import { DateTime } from 'luxon';

import { termsOfUse } from 'theSource/assets';
import { SubscriberResponseDto } from 'theSource/types';
import { AcceptTermsOfUseRequestDto, TermsOfUseLocalDetails } from '../types';

export const saveAgreementCheckToLocalStorage = (
  subscriberId: number
): void => {
  const agreement: TermsOfUseLocalDetails = {
    version: termsOfUse.version,
    checked: DateTime.now().toISO(),
  };
  localStorage.setItem(
    getTermsOfUseLocalStorageKey(subscriberId),
    JSON.stringify(agreement)
  );
};

export const mapToAcceptTermsOfUseRequestDto = (
  subscriber?: SubscriberResponseDto
): AcceptTermsOfUseRequestDto => ({
  subscriberId: subscriber?.data.id.value as number,
  versionDate: termsOfUse.version,
});

export const getTermsOfUseLocalStorageKey = (subscriberId: number): string =>
  `termsOfUse${subscriberId}`;
